<template>
  <v-container grid-list-xl fluid>
    <v-layout row wrap>
      <v-flex lg12  v-if="storeTQRole">
        <v-card>
          <hpo-filter
            :headers="headers"
            :viewName="viewName"
            v-on:applyFilter="applyFilter"
            v-on:quickFilter="quickFilter"
          ></hpo-filter>
          <v-data-table
            :headers="headers"
            :items="items"
            :options.sync="pagination"
            :server-items-length="total_rows"
            :footer-props="items_per_page"
            :must-sort="true"
            :loading="loading"
            :mobile-breakpoint="100"
          >
            <template v-slot:item="{ item }">
              <tr :id="'r-'+item.ID">
                <td>{{ item.PackageCode }}</td>
                <td class="text-right">{{ item.Weight }}</td>
                <td class="text-right">{{ item.Volume }}</td>
                <td class="text-right">{{ item.Length }}*{{ item.Width }}*{{ item.Height }}</td>
                <td>{{ item.CreatedDate | display_date }}</td>
                <td>{{ item.ExDate | display_date }}</td>
                <td class="text-center">
                  <v-tooltip top v-if="(packageRole & 4) && item.Status == bigPackageEnum.DANG_DONG_BAO">
                      <template v-slot:activator="{ on }">
                          <v-icon v-on="on" medium class="mr-2" @click="exportPackage(item.ID, item.PackageCode)">fa-shipping-fast</v-icon>
                      </template>
                      <span>Xuất kho</span>
                  </v-tooltip>
                  <v-tooltip top v-if="adminRole && item.Status == bigPackageEnum.XUAT_KHO_TQ">
                      <template v-slot:activator="{ on }">
                          <v-icon v-on="on" medium class="mr-2" @click="undoExportPackage(item.ID, item.PackageCode)">fa-undo</v-icon>
                      </template>
                      <span>Huỷ xuất kho</span>
                  </v-tooltip>
                  <v-icon medium class="mr-2" @click="gotoDetail(item.ID)"> {{ (packageRole & 8) && item.Status == bigPackageEnum.DANG_DONG_BAO ? 'fa-edit' : 'fa-external-link-alt'}}</v-icon>
                  <v-icon medium class="mr-2" color="red darken-2" @click="printPackage(item.ID)">fa-print</v-icon>
                  <v-tooltip top v-if="(packageRole & 4) && item.Status == bigPackageEnum.DANG_DONG_BAO">
                      <template v-slot:activator="{ on }">
                          <v-icon v-on="on" medium @click="deleteItem(item.ID)">fa-trash-alt</v-icon>
                      </template>
                      <span>Xoá bao hàng</span>
                  </v-tooltip>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>   
      <v-flex lg12  v-else-if="storeVNRole">
        <v-card>
          <hpo-filter
            :headers="headers"
            :viewName="viewName"
            v-on:applyFilter="applyFilter"
            v-on:quickFilter="quickFilter"
          ></hpo-filter>
          <v-data-table
            :headers="headers"
            :items="items"
            :options.sync="pagination"
            :server-items-length="total_rows"
            :footer-props="items_per_page"
            :must-sort="true"
            :loading="loading"
            :mobile-breakpoint="100"
          >
            <template v-slot:item="{ item }">
              <tr :id="'r-'+item.ID">
                <td>{{ item.PackageCode }}</td>
                <td class="text-right">{{ item.Weight }}</td>
                <td class="text-right">{{ item.Volume }}</td>
                <td class="text-right">{{ item.Length }}*{{ item.Width }}*{{ item.Height }}</td>
                <td>{{ item.ExDate | display_date }}</td>
                <td>{{ item.ImDate | display_date }}</td>
                <td class="text-center">
                  <v-tooltip top v-if="(packageRole & 4) && item.Status == bigPackageEnum.DANG_DONG_BAO">
                      <template v-slot:activator="{ on }">
                          <v-icon v-on="on" medium class="mr-2" @click="exportPackage(item.ID, item.PackageCode)">fa-shipping-fast</v-icon>
                      </template>
                      <span>Xuất kho</span>
                  </v-tooltip>
                  <v-tooltip top v-if="adminRole && item.Status == bigPackageEnum.XUAT_KHO_TQ">
                      <template v-slot:activator="{ on }">
                          <v-icon v-on="on" medium class="mr-2" @click="undoExportPackage(item.ID, item.PackageCode)">fa-undo</v-icon>
                      </template>
                      <span>Huỷ xuất kho</span>
                  </v-tooltip>
                  <v-icon medium class="mr-2" @click="gotoDetail(item.ID)"> {{ (packageRole & 8) && item.Status == bigPackageEnum.DANG_DONG_BAO ? 'fa-edit' : 'fa-external-link-alt'}}</v-icon>
                  <v-icon medium class="mr-2" color="red darken-2" @click="printPackage(item.ID)">fa-print</v-icon>
                  <v-tooltip top v-if="(packageRole & 4) && item.Status == bigPackageEnum.DANG_DONG_BAO">
                      <template v-slot:activator="{ on }">
                          <v-icon v-on="on" medium @click="deleteItem(item.ID)">fa-trash-alt</v-icon>
                      </template>
                      <span>Xoá bao hàng</span>
                  </v-tooltip>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
      <v-flex lg12  v-else>
        <v-card>
          <hpo-filter
            :headers="headers"
            :viewName="viewName"
            v-on:applyFilter="applyFilter"
            v-on:quickFilter="quickFilter"
          ></hpo-filter>
          <v-data-table
            :headers="headers"
            :items="items"
            :options.sync="pagination"
            :server-items-length="total_rows"
            :footer-props="items_per_page"
            :must-sort="true"
            :loading="loading"
            :mobile-breakpoint="100"
          >
            <template v-slot:item="{ item }">
              <tr :id="'r-'+item.ID">
                <td>{{ item.PackageCode }}</td>
                <td class="text-right">{{ item.Weight }}</td>
                <td class="text-right">{{ item.Volume }}</td>
                <td class="text-right">{{ item.Length }}*{{ item.Width }}*{{ item.Height }}</td>
                <td>{{ item.CreatedDate | display_date }}</td>
                <td>{{ item.ExDate | display_date }}</td>
                <td>{{ item.ImDate | display_date }}</td>
                <td class="text-center">
                  <v-tooltip top v-if="(packageRole & 4) && item.Status == bigPackageEnum.DANG_DONG_BAO">
                      <template v-slot:activator="{ on }">
                          <v-icon v-on="on" medium class="mr-2" @click="exportPackage(item.ID, item.PackageCode)">fa-shipping-fast</v-icon>
                      </template>
                      <span>Xuất kho</span>
                  </v-tooltip>
                  <v-tooltip top v-if="adminRole && item.Status == bigPackageEnum.XUAT_KHO_TQ">
                      <template v-slot:activator="{ on }">
                          <v-icon v-on="on" medium class="mr-2" @click="undoExportPackage(item.ID, item.PackageCode)">fa-undo</v-icon>
                      </template>
                      <span>Huỷ xuất kho</span>
                  </v-tooltip>
                  <v-icon medium class="mr-2" @click="gotoDetail(item.ID)"> {{ (packageRole & 8) && item.Status == bigPackageEnum.DANG_DONG_BAO ? 'fa-edit' : 'fa-external-link-alt'}}</v-icon>
                  <v-icon medium class="mr-2" color="red darken-2" @click="printPackage(item.ID)">fa-print</v-icon>
                  <v-tooltip top v-if="(packageRole & 4) && item.Status == bigPackageEnum.DANG_DONG_BAO">
                      <template v-slot:activator="{ on }">
                          <v-icon v-on="on" medium @click="deleteItem(item.ID)">fa-trash-alt</v-icon>
                      </template>
                      <span>Xoá bao hàng</span>
                  </v-tooltip>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
       <big-package-popup
        :readOnly="!((packageRole & 8) && currentItem.Status == bigPackageEnum.DANG_DONG_BAO)"
        :dialogPackageDetail="dialogPackageDetail"
        v-on:closePopup="closePopup"
        @deleteItem="deleteItem"
      ></big-package-popup>
    </v-layout>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import configs from "../../configs";
import big_package from "@/components/popups/big_package";
import Filtering from "@/components/Filtering";
import { sendErrorNotice } from "@/commons/utils";
import _ from "lodash";
import { print_bigpackage, request_detail } from "@/commons/hpod";
import Vue from 'vue';

export default {
  components: {
    "hpo-filter": Filtering,
    "big-package-popup": big_package,
  },
  data() {    
    return {      
      pagination: { ...configs.PAGINATION, sortBy: ["ID"]},
      items_per_page: _.cloneDeep(configs.ITEMS_PER_PAGE),
      viewName: "bigpackage_list",
      filterConditions: [],
      quickFilterConditions: [],
      requireRules: [v => !!v || "Trường dữ liệu không được để trống."],
      bigPackageEnum: configs.BIG_PACKAGE_STATUS_ENUM,
      dialogPackageDetail: false
    };
  },
  watch: {
    pagination: {
      handler: function(val, oldVal) {
        let filterConditions = this.$store.state.commons.filterConditions;
        this.filterConditions = !_.isEmpty(filterConditions)
          ? filterConditions[this.viewName]
          : [];
        this.filter_data();
      },
      deep: true
    },
    packageRole() {
      this.$root.$emit('REQUEST_ROOT_OPTION', {invisibleCreateButton: !(this.packageRole & 2)});
    }
  },
  computed: {
    ...mapState({
      items: state => state.bigPackage.all.data,
      total_rows: state => state.bigPackage.all.total,
      currentItem: state => state.bigPackage.selected,
      loading: state => state.bigPackage.loading
    }),
    packageRole() {
      return this.$store.state.authentication.role.BigPackage;
    },
    adminRole() {
      return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Admin) == configs.ROLE_TYPE.Admin;
    },
    storeVNRole() {
      return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.StoreVN) == configs.ROLE_TYPE.StoreVN;
    },
    storeTQRole() {
      return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.StoreTQ) == configs.ROLE_TYPE.StoreTQ || (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.StoreTQ2) == configs.ROLE_TYPE.StoreTQ2;
    },
    param() {
      return {
        pagination: this.pagination,
        filter: this.filterConditions,
        quickFilter: this.quickFilterConditions
      };
    },
    headers() {
      let dataType = configs.DATA_TYPE;
      let header_admin = [
        {
          text: "Bao hàng",
          value: "PackageCode",
          filterable: true,
          quickSearch: true,
          dataType: dataType["String"]
        },
        {
          text: "Cân nặng",
          value: "Weight",
          align: "end",
          filterable: true,
          dataType: dataType["Number"]
        },
        {
          text: "Số gói",
          value: "Volume",
          align: "end",
          filterable: true,
          dataType: dataType["Number"]
        },
        {
          text: "Kích thước (D*R*C)",
          value: "Length",
          align: "end",
          filterable: true,
          dataType: dataType["Number"]
        },
        {
          text: "Ngày tạo",
          value: "CreatedDate",
          filterable: true,
          dataType: dataType["Date"]
        },
        {
          text: "Ngày xuất kho",
          value: "ExDate",
          filterable: true,
          dataType: dataType["Date"]
        },
        {
          text: "Ngày nhập kho",
          value: "ImDate",
          filterable: true,
          dataType: dataType["Date"]
        },
        {
          text: "Thao tác",
          value: "",
          align: "center",
          sortable: false,
          filterable: false
        }
      ];

      if (this.storeVNRole) {
        header_admin = [
            {
              text: "Bao hàng",
              value: "PackageCode",
              filterable: true,
              quickSearch: true,
              dataType: dataType["String"]
            },
            {
              text: "Cân nặng",
              value: "Weight",
              align: "end",
              filterable: true,
              dataType: dataType["Number"]
            },
            {
              text: "Số gói",
              value: "Volume",
              align: "end",
              filterable: true,
              dataType: dataType["Number"]
            },
            {
              text: "Kích thước (D*R*C)",
              value: "Length",
              align: "end",
              filterable: true,
              dataType: dataType["Number"]
            },
            {
              text: "Ngày xuất kho",
              value: "ExDate",
              filterable: true,
              dataType: dataType["Date"]
            },
            {
              text: "Ngày nhập kho",
              value: "ImDate",
              filterable: true,
              dataType: dataType["Date"]
            },
            {
              text: "Thao tác",
              value: "",
              align: "center",
              sortable: false,
              filterable: false
            }
          ];
      }

      if (this.storeTQRole) {
        header_admin = [
            {
              text: "Bao hàng",
              value: "PackageCode",
              filterable: true,
              quickSearch: true,
              dataType: dataType["String"]
            },
            {
              text: "Cân nặng",
              value: "Weight",
              align: "end",
              filterable: true,
              dataType: dataType["Number"]
            },
            {
              text: "Số gói",
              value: "Volume",
              align: "end",
              filterable: true,
              dataType: dataType["Number"]
            },
            {
              text: "Kích thước (D*R*C)",
              value: "Length",
              align: "end",
              filterable: true,
              dataType: dataType["Number"]
            },
            {
              text: "Ngày tạo",
              value: "CreatedDate",
              filterable: true,
              dataType: dataType["Date"]
            },
            {
              text: "Ngày xuất kho",
              value: "ExDate",
              filterable: true,
              dataType: dataType["Date"]
            },
            {
              text: "Thao tác",
              value: "",
              align: "center",
              sortable: false,
              filterable: false
            }
          ];
      }
      return header_admin;
    }
  },
  methods: {
    filter_data: function() {
      this.$store.dispatch("bigPackage/getList", this.param);
    },
    exportPackage(id, package_code) {
      window.getApp.$emit("REQUEST_CONFIRM_ACTION", 'ExportStoreCN', id, `Bạn có chắc chắn xuất kho bao hàng ${package_code} không?`);
    },
    undoExportPackage(id, package_code) {
      window.getApp.$emit("REQUEST_CONFIRM_ACTION", 'UnExportStoreCN', id, `Bạn có chắc chắn huỷ xuất kho bao hàng ${package_code} không?`);
    },
    printPackage(id) {
      request_detail('bigpackage/print', ret => {
          let item = ret.data;
          print_bigpackage(item.PackageCode, item.CreatedDate, item.ExDate, item.NumberOfPack, item.Weight, item.Volume, item.ProductNumber);
      }, Vue.http, id, this.$store.state.authentication.token);
    },
    gotoDetail: function(id) {
      let configPaging = _.cloneDeep(configs.PAGINATION);
      configPaging.itemsPerPage = 5;
      var param = {
         pagination: {
            ...configPaging,
            itemsPerPage: 1000000
          }
      };
      
      this.$store.dispatch("bigPackage/getDetail", {'id': id, 'param': param});
      setTimeout(() => {this.dialogPackageDetail = true}, 200);
    },
    deleteItem: function(id) {
      if(this.packageRole & 4) {
        window.getApp.$emit("REQUEST_DELETE_DATA", id);
      }
      else {
        sendErrorNotice('Bạn không có quyền xóa bao hàng.')
      }
    },    
    applyFilter(filterConditions) {
      let sortBy = this.pagination.sortBy;
      let sortDesc = this.pagination.sortDesc;
      this.pagination = configs.PAGINATION;
      this.pagination.sortBy = sortBy;
      this.pagination.sortDesc = sortDesc;
      this.filterConditions = filterConditions;
      this.filter_data();
    },
    quickFilter(filterConditions) {
      this.quickFilterConditions = filterConditions;
      this.filter_data();
    },
    createData(username = "") {
      if(this.packageRole & 2) {
        this.$store.commit("bigPackage/setDetail", {
          data: {
            ID: 0,
            PackageCode: '',
            ReceivePlaceID: 1,
            Weight: 0,
            Volume: 0,
            Amount: 0,
            Status: 0,
            Packages: []
          }
        });
        this.dialogPackageDetail = true;
      }
      else {
        sendErrorNotice('Bạn không có quyền thêm mới bao hàng.')
      }
    },
    saveItem(item) {
      this.$store.dispatch("bigPackage/setDetail", {
        data: item,
        id: item.ID,
        param: this.param
      });
    },
    saveData() {
      this.saveItem(this.currentItem);
      this.dialogPackageDetail = false;
    },
    closePopup() {
      this.dialogPackageDetail = false;
      setTimeout(this.filter_data, 200);
    }
  },
  mounted() {
    this.$root.$emit('REQUEST_ROOT_OPTION', {invisibleCreateButton: !(this.packageRole & 2)});
    this.$root.$on("REQUEST_CREATE_DATA", this.createData);
    this.$root.$on("REQUEST_REFRESH_DATA", this.filter_data);
    this.$root.$on("CONFIRMED_REMOVE_DATA", id => {
      this.$store.dispatch("bigPackage/removeDetail", id);
      setTimeout(this.filter_data, 200);
    });
    this.$root.$on("CONFIRMED_ACTION", ({action, id}) => {
      if(action == 'ExportStoreCN') {
        this.saveItem({
          ID: id,
          Status: configs.BIG_PACKAGE_STATUS_ENUM.XUAT_KHO_TQ
        });
      }
      else if(action == 'UnExportStoreCN') {
        this.saveItem({
          ID: id,
          Status: configs.BIG_PACKAGE_STATUS_ENUM.DANG_DONG_BAO
        });
      }
    });
  },
  beforeDestroy() {
    this.$root.$off("REQUEST_CREATE_DATA", this.createData);
    this.$root.$off("REQUEST_REFRESH_DATA", this.filter_data);
    this.$root.$off("CONFIRMED_REMOVE_DATA");
    this.$root.$off("CONFIRMED_ACTION");
  }
};
</script>
